import { render, staticRenderFns } from "./DistrictList.vue?vue&type=template&id=7460cd91&scoped=true&"
import script from "./DistrictList.vue?vue&type=script&lang=ts&"
export * from "./DistrictList.vue?vue&type=script&lang=ts&"
import style0 from "./DistrictList.vue?vue&type=style&index=0&id=7460cd91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7460cd91",
  null
  
)

export default component.exports